"use client"

import { ToastStack, type ToastPosition, type ToastStackClassNames } from "./toast-stack"
import { dismissToast, useToasts } from "./toast-store"

export interface ToastHostProps {
  position?: ToastPosition
  maxVisible?: number
  className?: string
  classNames?: ToastStackClassNames
}

/**
 * Renders the global toast queue. Mount once at the app root; `toast()` from
 * anywhere then surfaces here.
 *
 * Portals to the body so it is never clipped by an ancestor's `overflow` — the
 * sidebar's width transition sets exactly that.
 */
export function ToastHost({
  position = "top-right",
  maxVisible = 4,
  className,
  classNames,
}: ToastHostProps) {
  const toasts = useToasts()
  return (
    <ToastStack
      toasts={toasts}
      onDismiss={dismissToast}
      position={position}
      placement="fixed"
      portal
      maxVisible={maxVisible}
      className={className}
      classNames={classNames}
    />
  )
}
